export type SessionRuntime = {
  currentUserId?: string
  impersonatedUserId?: string
  isImpersonating: boolean
  canImpersonate: boolean
  sessionScopeKey: string
}

export const PUBLIC_SESSION_SCOPE_KEY = 'public'

export const PUBLIC_SESSION_RUNTIME: SessionRuntime = {
  currentUserId: undefined,
  impersonatedUserId: undefined,
  isImpersonating: false,
  canImpersonate: false,
  sessionScopeKey: PUBLIC_SESSION_SCOPE_KEY,
}

export function buildRestrictedSessionScopeKey(
  currentUserId: string | undefined,
  impersonatedUserId?: string,
): string {
  if (!currentUserId) return PUBLIC_SESSION_SCOPE_KEY

  return impersonatedUserId
    ? `restricted:${currentUserId}:impersonating:${impersonatedUserId}`
    : `restricted:${currentUserId}`
}

export function createRestrictedSessionRuntime(
  currentUserId: string | undefined,
  impersonatedUserId?: string,
  options?: {
    canImpersonate?: boolean
  },
): SessionRuntime {
  if (!currentUserId) {
    return PUBLIC_SESSION_RUNTIME
  }

  return {
    currentUserId,
    impersonatedUserId,
    isImpersonating: Boolean(impersonatedUserId),
    canImpersonate: options?.canImpersonate ?? false,
    sessionScopeKey: buildRestrictedSessionScopeKey(
      currentUserId,
      impersonatedUserId,
    ),
  }
}
